import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component
export default class DeleteAccountFirstStepComponent extends Vue {
  @appStoreState.Getter
  getIsOpenFirstStepDeleteAccountModal!: boolean;

  @appStoreState.Mutation
  public setIsOpenFirstStepDeleteAccountModal!: (payload: any) => void;

  @appStoreState.Mutation
  public setIsOpenSecondStepDeleteAccountModal!: (payload: any) => void;

  tempUserName = this.$store.getters?.userIdentity?.lastName || '';
  deleteReason = 1;
  showRequiredMessage = false;

  mounted() {
    this.tempUserName = this.$store.getters?.userIdentity?.lastName || '';
  }

  handleCloseModal(): void {
    this.setIsOpenFirstStepDeleteAccountModal(false);
  }

  handleNextStep() {
    if (Number(this.deleteReason) === 1) {
      this.showRequiredMessage = true;
      return;
    }
    this.showRequiredMessage = false;
    this.setIsOpenFirstStepDeleteAccountModal(false);
    this.setIsOpenSecondStepDeleteAccountModal(true);
  }
}
